// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"purify_DpfSoot__iconContainer___39VYc","iconWrapper":"purify_DpfSoot__iconWrapper___3fXLs"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/Diesel/DieselService/DpfSoot/DpfSoot.scss
// module id = 206
// module chunks = 0